//import { Pane, Text } from "evergreen-ui";
import MMS from "./MM";
function App() {
  return (<MMS/>);
}
export default App;
